import { render, staticRenderFns } from "./CommessePers.vue?vue&type=template&id=faed2abc&scoped=true"
import script from "./CommessePers.vue?vue&type=script&lang=js"
export * from "./CommessePers.vue?vue&type=script&lang=js"
import style0 from "./CommessePers.vue?vue&type=style&index=0&id=faed2abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faed2abc",
  null
  
)

export default component.exports